<header id="main_header" class="fixedHeader" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1000">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <nav class="navbar navbar-expand-xl navbar-light">
                    <a class="navbar-brand" [routerLink]="['/']" routerLinkActive="active">
                        <!-- <img src="../../../assets/images/trinka-logo.png" /> -->
                        <img src="../../../assets/images/trinka_logo.svg" alt="trinka-grammar-checker">
                    </a>

                    <div class="mobile_buttons">
                        <button class="mobile_try_a_demo_button">Try A Demo</button>
                        <a id="mobile_singupButton" class="mobile_login" href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">
                            <span>Cadastre-se
                                <span class="small_mobile_only">Grátis</span>
                            </span>
                            <i class="fa fa-sign-in" aria-hidden="true"></i>
                        </a>
                        <a class="mobile_login" id="mobile_loginButton" href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">
                            <span class="diplay_none_for_icons">Login</span>
                            <i class="fa fa-sign-in display_block_for_text" aria-hidden="true"></i>
                        </a>

                        <div class="navbar-nav ml-auto loginarea">

                        </div>

                        <button type="button" class="navbar-toggler" id="mobile_menu_toggle" data-toggle="collapse" data-target="#navbarCollapse">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 384.97 384.97" style="enable-background:new 0 0 384.97 384.97;" xml:space="preserve">
                                <g>
                                    <g id="Menu_1_">
                                        <path d="M12.03,120.303h360.909c6.641,0,12.03-5.39,12.03-12.03c0-6.641-5.39-12.03-12.03-12.03H12.03
                         c-6.641,0-12.03,5.39-12.03,12.03C0,114.913,5.39,120.303,12.03,120.303z" />
                                        <path d="M372.939,180.455H12.03c-6.641,0-12.03,5.39-12.03,12.03s5.39,12.03,12.03,12.03h360.909c6.641,0,12.03-5.39,12.03-12.03
                         S379.58,180.455,372.939,180.455z" />
                                        <path d="M372.939,264.667H132.333c-6.641,0-12.03,5.39-12.03,12.03c0,6.641,5.39,12.03,12.03,12.03h240.606
                         c6.641,0,12.03-5.39,12.03-12.03C384.97,270.056,379.58,264.667,372.939,264.667z" />
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </button>
                        <div id="body_overlay_section"></div>
                    </div>

                    <div class="collapse navbar-collapse" id="navbarCollapse">
                        <ul class="navbar-nav mr-auto">

                            <!-- <li class="nav-item">
                                <a class="nav-link" [routerLink]="['']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
                            </li> -->
                            <li class="nav-item dropdown" id="main_sub_menus">
                                <a class="nav-link dropdown-toggle" href="" id="dropdown04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Apps
                                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                                <div class="dropdown-menu" id="Home_sub_menus" aria-labelledby="dropdown04">
                                    <a class="nav-link" [routerLink]="['/trinkacloud']" routerLinkActive="active">
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud"> Trinka Cloud</a>

                                    <a class="nav-link" [routerLink]="['/wordplugin']" routerLinkActive="active">
                                        <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">MS Word Plugin</a>

                                    <a class="nav-link" [routerLink]="['/browser-plugin']" routerLinkActive="active">
                                        <img src="../../../assets/images/other_Apps_browser.svg" alt="browser plugin"> Plugins do navegador</a>

                                    <!-- <a class="nav-link" [routerLink]="['/auto-edit']" routerLinkActive="active">
                                        <img src="../../../assets/images/autoFileEdit_icon.svg" alt="auto file edit"> Auto Edit</a> -->
                                </div>
                            </li>
                            <li class="nav-item dropdown" id="feature_main_sub_menus">
                                <a class="nav-link dropdown-toggle" [routerLink]="['/features']" id="dropdown05" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">Características
                                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                                <div class="dropdown-menu" id="feature_sub_menus" aria-labelledby="dropdown05">
                                    <a class="nav-link" [routerLink]="['/features']" routerLinkActive="active">
                                        Todos os recursos
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/plagiarism-check']" routerLinkActive="active">
                                        Verificação de Plágio
                                    </a>
                                    <a class="nav-link" href="https://www.trinka.ai/pt/features/auto-file-edit" routerLinkActive="active">
                                        Edição automática de arquivos
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/latex-grammar-checker']" routerLinkActive="active">
                                        Verificador de Gramática LaTex <div class="beta-badge">Novo</div>
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/paraphraser']" routerLinkActive="active">
                                        Parafraseador On-line <div class="beta-badge">Novo</div>
                                    </a>
                                    <a class="nav-link" href="https://www.trinka.ai/pt/features/publication-readiness-checks" routerLinkActive="active">
                                        Verificações de prontidão para publicação
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/citation-checker']" routerLinkActive="active">
                                        Verificador de Citações
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/consistency-check']" routerLinkActive="active">
                                        Verificação de Consistência
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/personal-dictionary']" routerLinkActive="active">
                                        Dicionário Pessoal
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/credits']" routerLinkActive="active">
                                        Créditos em Trinka
                                    </a>
                                </div>
                            </li>
                            <!-- <li class="nav-item" id="featureMenu">
                                <a class="nav-link" [routerLink]="['/features']" routerLinkActive="active">Características</a>
                            </li> -->
                            <!-- <li class="nav-item" id="exampleMenu">
                                <a class="nav-link" [routerLink]="['/examples']" routerLinkActive="active">Exemplos</a>
                            </li> -->
                            <li class="nav-item" id="pricingMenu">
                                <a class="nav-link" [routerLink]="['/pricing']" routerLinkActive="active">Preços</a>
                            </li>
                            <li class="nav-item dropdown" id="enterprise_main_sub_menus">
                                <a class="nav-link" id="enterpriseMainMenu" [routerLink]="['/enterprise']" routerLinkActive="active">Empresa
                                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                                <div class="dropdown-menu" id="enterprise_sub_menus" aria-labelledby="dropdown04">
                                    <a class="nav-link" [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']" routerLinkActive="active">
                                        Ciências Biológicas, Medicina e Farmacêutica
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/language-services-publishing-and-media']" routerLinkActive="active">
                                        Serviços de Linguagem, Publicação & Midia
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/academic-institutions']" routerLinkActive="active">
                                        Instituições Acadêmicas
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/k12-and-elearning']" routerLinkActive="active">
                                        K-12 e E-Learning
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/technology-platforms']" routerLinkActive="active">
                                        Plataformas de Tecnologia
                                    </a>
                                    <!-- <a class="nav-link" [routerLink]="['/enterprise/grammar-checker-api']" routerLinkActive="active">
                                        API de Verificação Gramatical
                                    </a> -->
                                </div>
                            </li>
                            <li class="nav-item dropdown" id="resources_main_sub_menus">
                                <a class="nav-link" href="javascript:void(0)"  routerLinkActive="active">Recursos
                                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                                <div class="dropdown-menu" id="resources_sub_menus" aria-labelledby="dropdown06" style="min-width: 290px;">
                                    <a class="nav-link" [routerLink]="['/grammar-checker']" routerLinkActive="active">
                                        Verificador gramatical
                                    </a>
                                    <!-- <a class="nav-link" [routerLink]="['/paraphrasing-tool']" routerLinkActive="active">
                                        <span>Ferramenta On-line de Paráfrase</span> <div class="beta-badge">Novo</div>
                                    </a>
                                    <a class="nav-link" [routerLink]="['/ai-content-detector']" routerLinkActive="active">
                                        <span>Detector de Conteúdo de IA</span> <div class="beta-badge">Novo</div>
                                    </a> -->
                                    <a class="nav-link" [routerLink]="['/punctuation-checker']" routerLinkActive="active">
                                        Verificador de Pontuação
                                    </a>
                                    <a class="nav-link" [routerLink]="['/spell-checker']" routerLinkActive="active">
                                        Verificador Ortográfico
                                    </a>
                                    <a class="nav-link" [routerLink]="['/sentence-checker']" routerLinkActive="active">
                                        Verificador de Frases
                                    </a>
                                </div>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="apiGrammarChecker" [routerLink]="['/enterprise/grammar-checker-api']" routerLinkActive="active">API</a>
                            </li>
                            <!-- <li class="nav-item" id="tryAdemoMenu">
                                <a class="nav-link" [routerLink]="['/try-a-demo']" routerLinkActive="active">Experimente Grátis</a>
                            </li> -->
                        </ul>
                        <div class="navbar-nav ml-auto loginarea">
                            <a id="SignupForFree" class="nav-item nav-link login_buttons signup_buttons_new" href="https://cloud.trinka.ai/signup?_rg=PT"
                                target="_blank">Cadastre-se Grátis </a>
                            <a id="loginButtons" class="nav-item nav-link login_buttons login_buttons_new" href="https://cloud.trinka.ai/signup?_rg=PT"
                                target="_blank">Login</a>
                        </div>
                    </div>


                    <div class="language_sections" id="languageDropDown">
                        <i class="fa fa-globe" aria-hidden="true"></i>
                        <span>Português</span>
                        <ul class="drop">
                            <li>
                                <a href="https://www.trinka.ai">
                                    English
                                </a>
                            </li>
                            <li>
                                <a href="https://www.trinka.ai/jp/">
                                    日本語
                                </a>
                            </li>
                            <li>
                                <a href="https://trinka.enago.cn/">
                                    简体中文
                                </a>
                            </li>
                            <li>
                                <a href="https://www.trinka.ai/tw/">
                                    繁体中文
                                </a>
                            </li>
                            <li>
                                <a href="https://www.trinka.ai/kr/">
                                    한국어
                                </a>
                            </li>
                            <li>
                                <a href="https://www.trinka.ai/es/">
                                    Español
                                </a>
                            </li>
                            <li class="selected">
                                <i class="fa fa-check" aria-hidden="true"></i>
                                <a>Português</a>
                            </li>
                        </ul>
                    </div>

                </nav>
            </div>
        </div>
    </div>
</header>